export default "__VITE_ASSET__gYlQY8ak__"